import React from "react";
import { CHANNEL_TEXT } from "../../core/theme/channelColors";
import { scanProgress } from "../../core/data/jobs";

// Progress bar, Stop button and live preview while a job runs.
export default function ScanningScreen({ activeJob, recentAppearances, onStop }) {
  const { totalUnits, currentRound } = scanProgress(activeJob);

  return (
    <div>
      <div className="bg-white border border-slate-200 rounded-xl px-6 py-5 mb-6">
        <div className="flex items-center justify-between mb-3">
          <div>
            <p className="font-semibold text-slate-800 text-sm">{activeJob?.status === "stopped" ? "Stopped" : "Gathering data…"}</p>
            <p className="text-xs text-slate-400 mt-0.5">{activeJob ? `Round ${currentRound} of ${activeJob.rounds}` : "Starting..."}</p>
          </div>
          <button onClick={onStop} className="bg-red-50 text-red-600 border border-red-200 hover:bg-red-100 px-4 py-2 rounded-lg text-xs font-semibold transition-colors">⏹ Stop</button>
        </div>
        <div className="h-2 bg-violet-100 rounded-full overflow-hidden">
          <div className="h-full bg-violet-400 rounded-full transition-all duration-500" style={{ width: `${totalUnits > 0 ? Math.min(100, (activeJob.completed_units / totalUnits) * 100) : 0}%` }} />
        </div>
        <p className="text-xs text-slate-400 mt-2">{activeJob ? activeJob.completed_units : 0} of {totalUnits} searches complete</p>
      </div>
      {recentAppearances.length > 0 && (
        <div className="bg-white border border-slate-200 rounded-xl px-6 py-4">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">Live Preview</p>
          <div className="space-y-1">
            {recentAppearances.map(a => (
              <div key={a.id} className="flex items-center gap-3 text-xs text-slate-600 py-1">
                <span className={`font-semibold ${CHANNEL_TEXT[a.channel] || "text-slate-600"}`}>{a.channel.toUpperCase()}</span>
                <span className="font-medium text-violet-600">"{a.keyword}"</span>
                <span className="bg-slate-100 px-1.5 py-0.5 rounded">{a.location}</span>
                <span className="text-slate-700 truncate max-w-xs">{a.business_domain || a.raw_name}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
